import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import { Container, Grid, Toolbar } from '@material-ui/core';

import Empresa from 'src/modules/usuario/pages/empresa';

import { useStyles } from './styles';

function EmpresaPrimeiroAcesso() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar className={classes.appBar}>
        <Toolbar>
          <Grid container>
            <Grid item xs={6} sm={6}>
              <img
                src="/logo-white.png"
                alt="Xmei Logo"
                style={{
                  width: 72,
                  height: 45,
                  cursor: 'pointer',
                  padding: '10 0',
                }}
              />
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <main className={classes.content}>
        <div className={classes.drawerHeader} />
        <Container fixed>
          <Empresa isCadastroNovo />
        </Container>
      </main>
    </div>
  );
}

export default EmpresaPrimeiroAcesso;
